import { ReactNode, useCallback, useMemo, useState } from 'react';
import { FileUploadContext } from './FileUploadContext';
import { FileUpload } from './types';

export const FileUploadProvider = ({ children }: { children: ReactNode }) => {
  const [fileUpload, setFileUpload] = useState<FileUpload>({
    files: undefined,
    useCase: undefined,
  });

  const addFile = useCallback((file: File) => {
    setFileUpload(previous => ({
      ...previous,
      files: [...(previous.files || []), file],
    }));
  }, []);

  const removeFile = useCallback((file: File) => {
    setFileUpload(previous => ({
      ...previous,
      files: previous.files?.filter(f => f !== file),
    }));
  }, []);

  const value = useMemo(() => ({ fileUpload, setFileUpload, addFile, removeFile }), [fileUpload, addFile, removeFile]);

  return <FileUploadContext.Provider value={value}>{children}</FileUploadContext.Provider>;
};
